import TakeAwaySettings from "./TakeAwaySettings";

export default TakeAwaySettings;